<template>
  <template v-if="!loading && profileLoaded">
    <template v-if="!(space_id === 'formateur' && !hasAcceptedRgpd)">
      <component
        v-if="component"
        v-bind:is="component" />
      <error
        v-else
        no_return_home />
    </template>
    <template v-else> </template>
  </template>
  <template v-else>
    <div class="w-full lg:h-full">
      <spinner
        sizes="w-20 h-20"
        thickness="border-8" />
    </div>
  </template>

  <RgpdAcceptModal
    v-bind:modal_show="rgpdAcceptModal"
    v-bind:show_side_bar="true"
    v-bind:onclose="closeRgpdAcceptModal"
    v-bind:accept="acceptRgpdAndRefresh" />

  <refonte-modal-preferences
    v-bind:show="modalPreferences"
    v-bind:show_side_bar="true"
    v-bind:on_close="closePreferencesModal"
    title="Mes préférences de contact" />
</template>

<script setup lang="ts">
  import spinner from '@/components/utils/spinner.vue';
  import error from '@/views/errors/error-404.vue';
  import InscriptionAccueil from '@/views/_espace/_refonte/participant/accueil.vue';
  import InscriptionFormations from '@/views/_espace/_refonte/participant/formations.vue';
  import InscriptionFormationsDetails from '@/views/_espace/_refonte/participant/formations-details.vue';
  import InscriptionFormationsCursusDetails from '@/views/_espace/_refonte/participant/formations-details-cursus.vue';
  import InscriptionFormationsDetailsElearning from '@/views/_espace/_refonte/participant/formations-details-elearning.vue';
  import GestionAccueil from '@/views/_espace/_refonte/gestion/accueil.vue';
  import GestionInscriptions from '@/views/_espace/_refonte/gestion/inscriptions.vue';
  import GestionInscriptionsSession from '@/views/_espace/_refonte/gestion/inscriptions-details.vue';
  import GestionInscriptionsCursus from '@/views/_espace/_refonte/gestion/inscriptions-details-cursus.vue';
  import GestionInscriptionsElearning from '@/views/_espace/_refonte/gestion/inscriptions-details-elearning.vue';
  import GestionSessions from '@/views/_espace/_refonte/gestion/sessions.vue';
  import GestionSessionsDetails from '@/views/_espace/_refonte/gestion/sessions-details.vue';
  import GestionSessionsCursusSessionDetails from '@/views/_espace/_refonte/gestion/sessions-cursus-session-details.vue';
  import GestionSessionsCursusElearningDetails from '@/views/_espace/_refonte/gestion/sessions-cursus-elearning-details.vue';
  import GestionFactures from '@/views/_espace/_refonte/gestion/factures.vue';
  import GestionCommandes from '@/views/_espace/_refonte/gestion/commandes.vue';
  import GestionCommandesDetails from '@/views/_espace/_refonte/gestion/commandes-details.vue';
  import GestionInterlocuteurs from '@/views/_espace/_refonte/gestion/interlocuteurs.vue';
  import GestionEtablissements from '@/views/_espace/_refonte/gestion/etablissements.vue';
  import GestionAnnuaire from '@/views/_espace/_refonte/gestion/annuaire.vue';
  import GestionSatisfaction from '@/views/_espace/_refonte/gestion/satisfaction.vue';
  import GestionContrats from '@/views/_espace/_refonte/gestion/contrats.vue';
  import GestionDocuments from '@/views/_espace/_refonte/gestion/document.vue';
  import GestionEtablissementsDetails from '@/views/_espace/_refonte/gestion/etablissements-details.vue';
  import { computed, nextTick, onMounted, ref, Ref, watch } from 'vue';
  import { useArborescenceStore } from '@/stores/arborescence';
  import { useAccountStore } from '@/stores/account';
  import { useEntrepriseStore } from '@/stores/entreprise';
  import { useRoute, useRouter } from 'vue-router';
  import { useCatalogueStore } from '@/stores/catalogue';
  import { storeToRefs } from 'pinia';
  import { Entreprise } from '@/types/gestion/entreprise';
  import FormateurSessions from '@/views/_espace/_refonte/formateur/sessions.vue';
  import FormateurCv from '@/views/_espace/_refonte/formateur/cv.vue';
  import FormateurDocuments from '@/views/_espace/_refonte/formateur/document.vue';
  import FormateurAgenda from '@/views/_espace/_refonte/formateur/agenda.vue';
  import FormateurAppreciations from '@/views/_espace/_refonte/formateur/appreciations.vue';
  import FormateurSessionDetails from '@/views/_espace/_refonte/formateur/session-details.vue';
  import FormateurNavettes from '@/views/_espace/_refonte/formateur/navettes.vue';
  import FormateurContrats from '@/views/_espace/_refonte/formateur/contrats.vue';
  import ControleurdestagecacStagiaires from '@/views/_espace/_refonte/stage/_controleur/stagiaires.vue';
  import ControleurdestageecStagiaires from '@/views/_espace/_refonte/stage/_controleur/stagiaires.vue';
  import MaitredestageStagiaires from '@/views/_espace/_refonte/stage/_maitre/stagiaires.vue';
  import StagiaireElearning from '@/views/_espace/_refonte/stage/_stagiaire/ec/elearning.vue';
  import StagiaireSessions from '@/views/_espace/_refonte/stage/_stagiaire/sessions.vue';
  import StagiaireSessionDetails from '@/views/_espace/_refonte/stage/_stagiaire/details.vue';
  import StagiairecacSessions from '@/views/_espace/_refonte/stage/_stagiaire/sessions.vue';
  import StagiairecacInformations from '@/views/_espace/_refonte/stage/_stagiaire/cac/informations-cac.vue';
  import StagiairecacFormations from '@/views/_espace/_refonte/stage/_stagiaire/cac/formations-libres.vue';
  import StagiairecacSessionDetails from '@/views/_espace/_refonte/stage/_stagiaire/details.vue';
  import AccountInformations from '@/views/_espace/_refonte/compte/informations.vue';
  import AccountPreferences from '@/views/_espace/_refonte/compte/preferences.vue';
  import { useFormateurStore } from '@/stores/formateur';
  import RgpdAcceptModal from '@/views/_espace/_formateur/rgpd-accept-modal.vue';
  import RefonteModalPreferences from '@/components/refonte/modals/refonte-modal-preferences.vue';

  const props = withDefaults(
    defineProps<{
      space_id: string;
      sub_space_id: string;
    }>(),
    {}
  );

  const components: {
    [key: string]: any;
  } = {
    AccountPreferences,
    AccountInformations,
    StagiairecacSessionDetails,
    StagiairecacFormations,
    StagiairecacInformations,
    StagiairecacSessions,
    StagiaireSessionDetails,
    StagiaireSessions,
    StagiaireElearning,
    MaitredestageStagiaires,
    ControleurdestageecStagiaires,
    ControleurdestagecacStagiaires,
    FormateurContrats,
    FormateurNavettes,
    FormateurSessionDetails,
    FormateurAppreciations,
    FormateurAgenda,
    FormateurSessions,
    FormateurCv,
    FormateurDocuments,
    InscriptionAccueil,
    InscriptionFormations,
    InscriptionFormationsDetails,
    InscriptionFormationsCursusDetails,
    InscriptionFormationsDetailsElearning,
    GestionAccueil,
    GestionInscriptions,
    GestionInscriptionsSession,
    GestionInscriptionsCursus,
    GestionInscriptionsElearning,
    GestionSessions,
    GestionSessionsDetails,
    GestionSessionsCursusSessionDetails,
    GestionSessionsCursusElearningDetails,
    GestionCommandes,
    GestionCommandesDetails,
    GestionFactures,
    GestionInterlocuteurs,
    GestionEtablissements,
    GestionEtablissementsDetails,
    GestionAnnuaire,
    GestionSatisfaction,
    GestionContrats,
    GestionDocuments
  };
  const component = computed(() => {
    if (props.space_id && props.sub_space_id) {
      const rubriqueName =
        toPascalCase(props.space_id) + toPascalCase(props.sub_space_id);
      return components[rubriqueName];
    }
    return undefined;
  });

  const toPascalCase = (s: string) => {
    const stringArray = s.split('-');
    return stringArray
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
      .join('');
  };

  const loading: Ref<boolean> = ref(false);
  watch(
    () => props.space_id,
    async (newId) => {
      loading.value = true;
      closeRgpdAcceptModal();
      loadSubRubrique();
      arborescenceStore.setActiveSpaceId(props.space_id);
      arborescenceStore.setActiveSubSpaceId(props.sub_space_id);
      await fetchEspaceInfo(props.space_id);
      loading.value = false;
    }
  );
  watch(
    () => props.sub_space_id,
    (newId) => {
      loading.value = true;
      arborescenceStore.setActiveSubSpaceId(newId);
      loading.value = false;
    }
  );
  const route = useRoute();
  const router = useRouter();
  const arborescenceStore = useArborescenceStore();
  const accountStore = useAccountStore();
  const entrepriseStore = useEntrepriseStore();
  const formateurStore = useFormateurStore();
  const rubriquesFormateur = ref(null);
  const { entreprises, activeEntrepriseIds } = storeToRefs(entrepriseStore);
  const fetchUserInfo = async () => {
    await accountStore.getProfile();
    const profile = accountStore.profile;
    arborescenceStore.setSpace(
      'account',
      'restricted',
      !profile.hasValidateContactInfo
    );

    arborescenceStore.setSpace('gestion', 'restricted', !profile.entreprise);
    arborescenceStore.setSpace(
      'inscription',
      'restricted',
      !profile.participant
    );
    arborescenceStore.setSpace('formateur', 'restricted', !profile.formateur);
    arborescenceStore.setSpace(
      'controleurdestagecac',
      'restricted',
      !profile.controleurDeStageCAC
    );
    arborescenceStore.setSpace(
      'controleurdestageec',
      'restricted',
      !profile.controleurDeStageEC
    );
    arborescenceStore.setSpace(
      'maitredestage',
      'restricted',
      !profile.maitreDeStage
    );
    arborescenceStore.setSpace('stagiaire', 'restricted', !profile.stagiaire);
    arborescenceStore.setSpace(
      'stagiaireCAC',
      'restricted',
      !profile.stagiaireCAC
    );
    if (profile.showPopupPreferences) {
      openPreferencesModal();
    }

    if (!profile.hasValidateContactInfo) {
      await router.push('/account/informations');
    }
  };

  const catalogueStore = useCatalogueStore();
  const fetchEspaceInfo = async (spaceId: string) => {
    const { profile } = accountStore;
    if (spaceId === 'gestion' && profile.entreprise) {
      await entrepriseStore.getProfile();
      await entrepriseStore.initActiveEntrepriseIdFromQuery(
        route.query.clientIds
      );
      await catalogueStore.fetchCataloguesClients();
    }
    if (spaceId === 'inscription' && profile.participant) {
      await catalogueStore.fetchCatalogues();
    }

    if (spaceId === 'formateur' && profile.formateur) {
      await formateurStore.fetchFormateurProfile();
      rubriquesFormateur.value = formateurStore.profile;
      updateMenuFormateur(rubriquesFormateur);
    }
    updateMenu();
  };
  const profileLoaded = ref<boolean>(false);

  const updateMenu = () => {
    const selectedEntreprises =
      activeEntrepriseIds && activeEntrepriseIds.value.length > 0
        ? entreprises.value.filter((e) =>
            activeEntrepriseIds.value.some((a) => a === e.entrepriseId)
          )
        : entreprises.value;

    if (entrepriseStore.profile) {
      arborescenceStore.setSousRubrique(
        'gestion',
        'administration',
        'documents',
        'menuHidden',
        !entrepriseStore.profile.clientDocuments
      );
    }

    if (entreprises) {
      arborescenceStore.setSousRubrique(
        'gestion',
        'gestion',
        'contrats',
        'menuHidden',
        !(selectedEntreprises as Entreprise[]).some((e) => e.hasContrats)
      );
      arborescenceStore.setSousRubrique(
        'gestion',
        'gestion',
        'sessions',
        'menuHidden',
        !(selectedEntreprises as Entreprise[]).some((e) => e.hasSessionsIntra)
      );
    }
  };
  const updateMenuFormateur = (rubriquesFormateur: Ref<any>) => {
    if (!rubriquesFormateur.value.hasAcceptedRgpd) {
      arborescenceStore.showOrHideAllSousRubriques('formateur', true);
      openRgpdAcceptModal();
    } else if (rubriquesFormateur.value) {
      arborescenceStore.setSousRubrique(
        'formateur',
        'formateur',
        'navettes',
        'menuHidden',
        !rubriquesFormateur.value.candidature
      );

      arborescenceStore.setSousRubrique(
        'formateur',
        'formateur',
        'contrats',
        'menuHidden',
        !rubriquesFormateur.value.contrats
      );
      arborescenceStore.setSousRubrique(
        'formateur',
        'formateur',
        'documents',
        'menuHidden',
        !rubriquesFormateur.value.clientDocuments
      );
    }
  };

  watch(activeEntrepriseIds, () => {
    updateMenu();
  });
  onMounted(async () => {
    loading.value = true;
    loadSubRubrique();
    arborescenceStore.setActiveSpaceId(props.space_id);
    arborescenceStore.setActiveSubSpaceId(props.sub_space_id);
    await fetchUserInfo();
    await fetchEspaceInfo(props.space_id);
    profileLoaded.value = true;
    loading.value = false;

    const hash = route.hash;
    if (hash && hash.length > 1) {
      await nextTick();
      setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
          if (el.focus) {
            el.focus();
          }
        }
      }, 500);
    }
  });
  const loadSubRubrique = () => {
    if (!props.sub_space_id) {
      initSubRubrique();
    } else {
      validateSpaceAccess();
    }
  };
  const validateSpaceAccess = () => {
    //TODO validate not restricted + validate exist subSpace + validate hasAccess
  };
  const isValidSpace = () => {
    return Object.prototype.hasOwnProperty.call(
      arborescenceStore.arborescence,
      props.space_id
    );
  };

  const initSubRubrique = () => {
    if (isValidSpace()) {
      const firstSousRubrique = arborescenceStore.getFirstSousRubrique(
        props.space_id
      );
      router.push(`/${props.space_id}/${firstSousRubrique}`);
    } else {
      router.push('/');
    }
  };
  const hasAcceptedRgpd = computed(
    () => rubriquesFormateur.value?.hasAcceptedRgpd === true
  );

  const rgpdAcceptModal = ref(false);

  const openRgpdAcceptModal = () => {
    rgpdAcceptModal.value = true;
  };

  const closeRgpdAcceptModal = () => {
    rgpdAcceptModal.value = false;
  };

  const modalPreferences = ref(false);

  const openPreferencesModal = () => {
    modalPreferences.value = true;
  };

  const closePreferencesModal = () => {
    modalPreferences.value = false;
  };

  const acceptRgpdAndRefresh = async () => {
    await formateurStore.acceptRgpd();
    closeRgpdAcceptModal();
    await formateurStore.fetchFormateurProfile();
    rubriquesFormateur.value = formateurStore.profile;
    arborescenceStore.showOrHideAllSousRubriques('formateur', false);
    updateMenuFormateur(rubriquesFormateur);
  };
</script>

<style lang="scss" scoped></style>
